module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.nome),
      expression: "servico.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.servico.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.servico, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.descricao),
      expression: "servico.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.servico.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.servico, "descricao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Tempo (min)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.tempo),
      expression: "servico.tempo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.servico.tempo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.servico, "tempo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.categorias_id),
      expression: "servico.categorias_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.servico, "categorias_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.descricao))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Preço")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: (_vm.servico.preco),
      callback: function($$v) {
        _vm.$set(_vm.servico, "preco", $$v)
      },
      expression: "servico.preco"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "v-label"
  }, [_vm._v("Imagem")]), _c('br'), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "multiple": false,
      "id": "file-input"
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.servico.ativo),
      callback: function($$v) {
        _vm.$set(_vm.servico, "ativo", $$v)
      },
      expression: "servico.ativo"
    }
  })], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/servicos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar && !_vm.loading),
      expression: "habilitaGravar && !loading"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fedc8c70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Servicos/novoServico.vue
// module id = 1301
// module chunks = 1